import { render, staticRenderFns } from "./LlamadasPlaceHolder.vue?vue&type=template&id=7e1730fa&scoped=true"
import script from "./LlamadasPlaceHolder.vue?vue&type=script&lang=js"
export * from "./LlamadasPlaceHolder.vue?vue&type=script&lang=js"
import style0 from "./LlamadasPlaceHolder.vue?vue&type=style&index=0&id=7e1730fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1730fa",
  null
  
)

export default component.exports